import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import PageHeader from "../../../components/Common/PageHeader";
import TableFilterDynamique from "components/Common/TableFilter/TableFilterDynamique";
import AddEditSupplierModal from "../modals/AddEditSupplierModal";
import SuppliersTable from "../tables/SuppliersTable";
import useSuppliers from "../hooks/useSuppliers";
import { FilterField } from "../../../components/Common/TableFilter/TableFilter";
import useExpenseCategories from "../hooks/useExpenseCategories";
import SettingsLayout from "../components/SettingsLayout";
const Suppliers = () => {
  const { t } = useTranslation();
  const {
    suppliers,
    infoPagination,
    loading,
    error,
    selectedSupplier,
    setSelectedSupplier,
    isModalOpen,
    setIsModalOpen,
    fetchSuppliers,
    handleCreate,
    handleUpdate,
    handleDelete,
  } = useSuppliers();
  const { fetchExpenseCategories, categories } = useExpenseCategories();

  const breadcrumbItems = [
    { label: "dashboard", path: "/dashboard" },
    { label: "suppliers", active: true },
  ];

  const [filters, setFilters] = useState<{
    [key: string]: string | number | null;
  }>({});

  useEffect(() => {
    fetchSuppliers();
    fetchExpenseCategories();
  }, [fetchSuppliers, fetchExpenseCategories]);

  const filterFields: FilterField[] = [
    { key: "search", label: t("search"), type: "text" },
    { key: "expenseCategoryId", label: t("expense_categories"), type: "select", options: categories.map((category) => ({ label: category.name, value: category.id })) },
  ];

  const handleSaveSupplier = async (supplierData: any) => {
    if (selectedSupplier) {
      await handleUpdate(selectedSupplier.id, supplierData);
    } else {
      await handleCreate(supplierData);
    }
    setIsModalOpen(false);
  };

  const handleEdit = (record: any) => {
    setSelectedSupplier(record);
    setIsModalOpen(true);
  };

  const handleFilter = (newFilters: {
    [key: string]: string | number | null;
  }) => {
    setFilters(newFilters);
    fetchSuppliers(newFilters);
  };

  return (
    <SettingsLayout titleKey="suppliers" loading={loading}>
      <div className="d-flex mb-3 justify-content-end gap-2">
        <button
          className="btn btn-primary"
          onClick={() => {
            setSelectedSupplier(null);
            setIsModalOpen(true);
          }}
        >
          <i className="ti ti-plus me-2" />
          {t("add_supplier")}
        </button>
        <TableFilterDynamique
          fields={filterFields}
          filters={filters}
          onApply={(newFilters) => handleFilter(newFilters)}
          onReset={() => {
            setFilters({});
            fetchSuppliers({});
          }}
        />
      </div>

      <SuppliersTable
        dataSource={suppliers}
        onEdit={handleEdit}
        onDelete={handleDelete}
        loading={loading}
      />

      <AddEditSupplierModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        supplierData={selectedSupplier}
        onSave={handleSaveSupplier}
        expenseCategories={categories}

      />
    </SettingsLayout>
  );
};

export default Suppliers;